// utils/mapConfig.js
import L from 'leaflet';

// 1. OpenStreetMap
export const osmLayer = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
  maxZoom: 21
});

// 2. Esri
export const mapLink = '<a href="http://www.esri.com/">Esri</a> ';
export const wholink = 'i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community';
export const esriurl = 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

export const esri = L.tileLayer(esriurl, {
  attribution: mapLink + wholink,
  maxZoom: 18
});

export const osmapurl1 = 'https://map-service.osmap.id/mbtiles-mapservices.php?db=0-13.mbtiles&z={z}&x={x}&y={y}';
export const osmapurl2 = 'https://map-service.osmap.id/mbtiles-mapservices.php?db=14-18.mbtiles&z={z}&x={x}&y={y}';
export const osmapattr = 'OneSpiritMap by <a href="http://www.integrasiautama.com" target="_blank">Integrasia Utama</a>';

export const osmap1 = L.tileLayer(osmapurl1, { tms: true, minZoom: 0, maxZoom: 13, attribution: osmapattr });
export const osmap2 = L.tileLayer(osmapurl2, { tms: true, minZoom: 14, maxZoom: 18, attribution: osmapattr });
export const osmapGroup = new L.layerGroup([osmap1, osmap2]);

export const sateliteLayer = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
  maxZoom: 21,
  subdomains: ['mt1', 'mt2', 'mt3']
});

export const googleLayer = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&language=en', {
  maxZoom: 21,
  subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
});

export const baseMaps = {
  OpenStreetMap: osmLayer,
  'Satelite Map': sateliteLayer,
  'Google Map': googleLayer,
  Esri: esri,
  'One Spirit': osmapGroup
};
